import { useTranslation } from 'react-i18next';

import { ReactComponent as StarImage } from '../../../common/assets/magicMovie/star.svg';

interface MovieProps {
  title: string;
  id: string;
  image: string;
  selectedMovies?: string[];
  clickEvents: boolean;
  genre: string;
  score?: number;
  rating?: number;
  onMovieClick?: (id: string) => void;
  recommendedMovie?: boolean;
}

export const Movie: React.FC<MovieProps> = (props) => {
  const { t } = useTranslation(['magicMovie']);
  const { image, id, title, clickEvents, selectedMovies, recommendedMovie, genre, rating, score, onMovieClick } = props;
  const isSelected = selectedMovies?.includes(id);

  const onClickEvent = () => {
    onMovieClick?.(id);
  };

  return (
    <div className={`movie ${clickEvents ? '' : 'movieImage_recommended'}`}>
      <div
        className={`movieImage ${isSelected ? 'selected' : ''}`}
        style={{
          backgroundImage: `url(${image})`,
        }}
        onClick={clickEvents ? onClickEvent : undefined}
      ></div>
      <div
        style={{
          color: isSelected ? 'lime' : 'unset',
          margin: 0,
        }}
      >
        <div className="white movie-title">{title}</div>
      </div>
      {recommendedMovie && (
        <div className="recommeded-movie-additional-details-container">
          <div className="recommeded-movie-additional-details-flex-row">
            <div>
              <div className="recommeded-movie-additional-small-blue-text">{t('movie.genre')}</div>
              <div className="recommeded-movie-additional-white-normal-text">{genre}</div>
            </div>
            <div>
              <div className="recommeded-movie-additional-small-blue-text">{t('movie.rating')}</div>
              <div className="recommeded-movie-additional-white-normal-text">
                <StarImage /> &nbsp;{rating?.toPrecision(2)}
              </div>
            </div>
          </div>
          <div className="recommeded-movie-additional-details-flex-row">
            <div>
              <div className="recommeded-movie-additional-small-blue-text">{t('movie.score')}</div>
              <div className="recommeded-movie-additional-white-normal-text">{score?.toPrecision(3)}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Movie;
